import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import {
  setContactInfoErrorRoutine,
  mergeContactsRoutine
} from './routines';
import { checkContactInfo, mergeContacts } from '../../services/contactService';
import { successToast, errorToast } from '../../common/helpers/toastrHelper';

function* mergeContactsReq({ payload }: Routine<any>) {
  try {
    const { isValid } = yield call(checkContactInfo, {
      excludeIds: payload.ids,
      email: payload.email,
      phoneNumber: payload.phoneNumber
    });

    if (isValid) {
      yield call(mergeContacts, payload);
      yield put(mergeContactsRoutine.success());
      yield call(successToast, 'Merge successful', 'toast.mergeSuccess');
    } else {
      yield put(setContactInfoErrorRoutine.trigger(true));
    }
  } catch (error) {
    yield put(mergeContactsRoutine.failure(error.message));
    yield call(errorToast, error.message);
  }
}

function* watchMergeContactsReq() {
  yield takeEvery(mergeContactsRoutine.TRIGGER, mergeContactsReq);
}

export default function* mergeContactsSaga() {
  yield all([watchMergeContactsReq()]);
}
